'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002epages$002eenvelopes$002e$002dEnvelopes$002dView$0024$0024anon$00246 from "./presto.pages.envelopes.-Envelopes-View$$anon$6.js";
import * as $j_presto$002etypes$0024$002dCredential$002dHash$0024 from "./presto.types$-Credential-Hash$.js";
var $p;
/** @constructor */
function $c_Lpresto_pages_envelopes_EnvelopesView$$anon$5(outer) {
  this.bUI = null;
  this.bUG = null;
  this.bUH = false;
  this.bUE = null;
  this.bUF = false;
  this.bUJ = false;
  this.bUK = false;
  if ((outer === null)) {
    throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_NullPointerException__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_NullPointerException());
  }
  this.bUI = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
}
export { $c_Lpresto_pages_envelopes_EnvelopesView$$anon$5 as $c_Lpresto_pages_envelopes_EnvelopesView$$anon$5 };
$p = $c_Lpresto_pages_envelopes_EnvelopesView$$anon$5.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_pages_envelopes_EnvelopesView$$anon$5;
/** @constructor */
function $h_Lpresto_pages_envelopes_EnvelopesView$$anon$5() {
}
export { $h_Lpresto_pages_envelopes_EnvelopesView$$anon$5 as $h_Lpresto_pages_envelopes_EnvelopesView$$anon$5 };
$h_Lpresto_pages_envelopes_EnvelopesView$$anon$5.prototype = $p;
$p.a1 = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this, a);
});
$p.ad = (function() {
  return this.bUI;
});
$p.t = (function() {
  if ((!this.bUH)) {
    this.bUG = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("hash", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("location", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.bUH = true;
  }
  return this.bUG;
});
$p.ae = (function() {
  if ((!this.bUF)) {
    this.bUE = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dCredential$002dHash$0024.$m_Lpresto_types$CredentialHash$().gJ(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(new $j_presto$002epages$002eenvelopes$002e$002dEnvelopes$002dView$0024$0024anon$00246.$c_Lpresto_pages_envelopes_EnvelopesView$$anon$6(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()));
    this.bUF = true;
  }
  return this.bUE;
});
$p.w = (function() {
  if ((!this.bUK)) {
    this.bUJ = false;
    this.bUK = true;
  }
  return this.bUJ;
});
$p.ac = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredEncoder__encodeProduct__O__Lio_circe_JsonObject(this, a);
});
var $d_Lpresto_pages_envelopes_EnvelopesView$$anon$5 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_pages_envelopes_EnvelopesView$$anon$5, "presto.pages.envelopes.EnvelopesView$$anon$5", ({
  WB: 1,
  a: 1,
  k: 1,
  n: 1,
  o: 1,
  p: 1,
  d: 1
}));
export { $d_Lpresto_pages_envelopes_EnvelopesView$$anon$5 as $d_Lpresto_pages_envelopes_EnvelopesView$$anon$5 };
//# sourceMappingURL=presto.pages.envelopes.-Envelopes-View$$anon$5.js.map
